module.exports = __webpack_public_path__ + "static/media/user.8d9753dd.jpg";